import { RouterOutlet } from "@angular/router";
import { Component } from "@angular/core";

import { Toast } from "./components/wally-ui/toast/toast";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, Toast],
  templateUrl: "./app.html",
  styleUrl: "./app.css",
})
export class App {
  protected title = "Iza";
}
